import { Box, ButtonBase, IconButton } from '@material-ui/core';
import { alpha, makeStyles } from '@material-ui/core/styles';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import ReactPlayer, { ReactPlayerProps } from 'react-player';

import ButtonDownloadMidia from 'components/ButtonDownloadMidia';
import LegendaMensagem from 'components/LegendaMensagem';
import MessageBase, { MessageBaseProps } from 'components/MessageBase';

import MessageErrorFallback from './MessageErrorFallback';

type VideoMessageProps = MessageBaseProps;

const useStyles = makeStyles(({ palette, spacing }) => ({
  button: {
    width: '100%',
    '& > div > .react-player__preview, & > div > video': {
      borderRadius: spacing(1),
    },
  },
  iconButton: {
    color: palette.getContrastText(alpha(palette.common.black, 0.4)),
    backgroundColor: `${alpha(palette.common.black, 0.4)} !important`,
  },
  background: {
    borderRadius: spacing(1),
    color: palette.common.white,
    backgroundColor: alpha(palette.common.black, 0.86),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'absolute',
    bottom: 0,
    top: 0,
    left: 0,
    right: 0,
  },
}));

export default function VideoMessage(props: VideoMessageProps) {
  const classes = useStyles();

  try {
    const {
      mensagem: {
        id: mensagemId,
        midiaUrl,
        midiaTitulo,
        midiaUrlPrevia,
        midiaDownloadErro,
        atendimentoId,
        grupoChatId,
        baixando,
      },
    } = props;

    const playerOptions = {
      url: midiaUrl || '',
      light: midiaUrlPrevia || '',
      pip: true,
      controls: true,
      width: 320,
      height: 320,
      playIcon: midiaDownloadErro ? (
        <Box />
      ) : (
        <IconButton className={classes.iconButton}>
          <PlayArrowIcon color="inherit" fontSize="large" />
        </IconButton>
      ),
    } as ReactPlayerProps;

    return (
      <MessageBase {...props}>
        <Box position="relative" overflow="hidden">
          <ButtonBase
            className={classes.button}
            disabled={midiaDownloadErro || !midiaUrl}
            component="div"
            disableRipple
          >
            <ReactPlayer {...playerOptions} />
          </ButtonBase>

          {midiaDownloadErro && (
            <Box className={classes.background}>
              <ButtonDownloadMidia
                mensagemId={mensagemId}
                atendimentoId={atendimentoId}
                grupoChatId={grupoChatId}
                baixando={baixando}
              />
            </Box>
          )}
        </Box>

        <LegendaMensagem
          legenda={midiaTitulo}
          isMe={props?.fromMe}
          contatosMencionados={props.mensagem.contatosMencionados}
        />
      </MessageBase>
    );
  } catch (error) {
    return <MessageErrorFallback {...props} />;
  }
}
